export const marksTemperature = [
    {
        value: 0
    },
    {
        value: 0.1
    },
    {
        value: 0.2
    },
    {
        value: 0.3
    },
    {
        value: 0.4
    },
    {
        value: 0.5
    },
    {
        value: 0.6
    },
    {
        value: 0.7
    },
    {
        value: 0.8
    },
    {
        value: 0.9
    },
    {
        value: 1
    },
];

export const initialStateAssistantAutocomplete = { id: 0, label: 'Selecione um assistente', disabled: true };

export const initialStateAssistant = {
    id: '0',
    model: 'gpt-4o-mini',
    name: '',
    flgActive: true,
    instructions: '',
    notInstructions: '',
    badWords: '',
    promptImage: '',
    temperature: 0,
    flgAPI: false,
    method: 1,
    urlAPI: '',
    typeToken: 'Authorization',
    token: 'Basic VXMz...',
    body: `{
    "parametro1": "{{parametro1}}",
    "parametro2": "{{parametro2}}",
}`,
    functions: `[
    {
        "type": "function",
        "function": {
            "name": "nomeFuncao",
            "description": "Descrição do que ela fez e quando vai fazer e quais váriaiveis vai usar durante a execução da instrução.",
            "parameters": {
                "type": "object",
                "properties": {
                    "variavel1": {
                        "type": "string",
                        "description": "Qual o contexto que ela se encaixa nas instruções"
                    },
                    "variavel2": {
                        "type": "string",
                        "description": "Qual o contexto que ela se encaixa nas instruções"
                    }
                },
                "required": [
                    "variavel1",
                    "variavel2"
                ]
            }
        }
    }
]`,
    assistant: {
        "name": "",
        "instructions": "",
        "model": "gpt-4o-mini",
        "temperature": 0.3,
        "tools": null
    },
    assistantOld: {}
};